import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'laas-close-dev-tools',
  templateUrl: './close-dev-tools.component.html',
  styleUrls: ['./close-dev-tools.component.scss']
})
export class CloseDevToolsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
